import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';

import { UiCard } from '../../components/ui/ui-card/ui-card';
import { RefundFeeExpress } from '../shared/refund-fee-express';
import { TripRoute } from './types';

type AgreementProps = {
  route: TripRoute;
};

export const Agreement = observer(({ route }: AgreementProps) => {
  return (
    <UiCard>
      <b style={{ color: 'tomato' }}>
        <Trans>Внимание!</Trans>
      </b>
      <br />
      <p>
        <Trans>
          При возврате группового билета возврату подлежат все места. Возврат
          отдельного места не производится.
        </Trans>
      </p>

      <RefundFeeExpress routeNumber={route.number} />
    </UiCard>
  );
});
